<template>
  <shell>
    <div class="container m-auto px-4 lg:px-0">
      <div class="flex items-center justify-between p-6">
        <t-hed lvl="2" class="">Choose a <strong>Spell</strong> type...</t-hed>
      </div>
      <div class="flex pb-6 px-6">
        <div class="pr-4"><router-link
                            to="/spells/create/email"
                            class="p-4 no-underline spell-tile email-digest">

          <t-hed lvl="3" class="text-off-white pb-2">Email Digest</t-hed>
          <t-text lvl="2" class="text-off-white">What&rsquo;s the use of writing it down if you never look at it?</t-text>
        </router-link></div>

        <div class="pr-4"><router-link
                            to="/spells/create/text"
                            class="bg-black p-4  spell-tile no-underline text-reminder">
          <t-hed lvl="3" class="text-off-white pb-2">Tap Tap</t-hed>

          <t-text lvl="2" class="text-off-white">Remind yourself to collect your thoughts.</t-text>
        </router-link></div>
      </div>
    </div>
  </shell>
</template>

<script>
 import Shell from '@/components/Shell';
 import SpellBar from '@/components/SpellBar';
 export default {
   components: {Shell, SpellBar}
 }
</script>


<style>
 
</style>
